import { type TLocation } from '../../types/location';

export function normalizeLocationId(location: TLocation): number {
  switch (location) {
    case 'moscow_mo':
      return -1;
    case 'spb_lo':
      return -2;
    default:
      return location.parentId || location.id;
  }
}
